import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { DetailPageLayout } from 'src/components/common';
import { PeoPayrollProviderStaffTable } from 'src/components/peoPayrollProvider';
import { ModalId } from 'src/constants/modals';
import { useFilterStorage } from 'src/hooks/common';
import { usePeoPayrollProviderParamId } from 'src/hooks/peoPayrollProvider';
import { usePeoPayrollProviderStaffsList } from 'src/hooks/peoPayrollProviderStaff/usePeoPayrollProviderStaffList';
import { useModal } from 'src/hooks/shared';
import {
  InvitePeoPayrollProviderStaffByCVStaffModal,
  PeoPayrollProviderStaffDetailsModal,
} from 'src/modals/peoPayrollProviderStaff';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoPayrollProviderDetailStaffPage: React.FC = () => {
  const peoPayrollProviderId = usePeoPayrollProviderParamId();

  const { openModal } = useModal();

  const { sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();

  const { peoPayrollProviderStaffsCount, peoPayrollProviderStaffsList, loading, refetch } =
    usePeoPayrollProviderStaffsList({
      filter: {
        peoPayrollProviderId: { equals: peoPayrollProviderId },
      },
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    });

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  const handleInviteStaff = React.useCallback(() => {
    openModal(ModalId.PeoPayrollProviderInviteStaffModal, { peoPayrollProviderId });
  }, [openModal, peoPayrollProviderId]);

  return (
    <DetailPageLayout
      titleContent="Staff"
      topRightContent={
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          loading={loading}
          disabled={loading}
          onClick={handleInviteStaff}
        >
          Invite
        </Button>
      }
    >
      <TableDataProvider>
        <PeoPayrollProviderStaffTable
          peoPayrollProviderId={peoPayrollProviderId}
          loading={loading}
          peoPayrollProviderStaffCount={peoPayrollProviderStaffsCount}
          peoPayrollProviderStaffList={peoPayrollProviderStaffsList}
          pagination={pagination}
          onRefresh={refetchData}
        />
        <InvitePeoPayrollProviderStaffByCVStaffModal peoPayrollProviderId={peoPayrollProviderId} />
      </TableDataProvider>

      <PeoPayrollProviderStaffDetailsModal />
    </DetailPageLayout>
  );
};
